var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgWarning = function SvgWarning(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3232 4.54545C10.5129 2.48485 13.4871 2.48485 14.6768 4.54546L20.9227 15.3636C22.1124 17.4242 20.6253 20 18.2459 20H5.75412C3.37474 20 1.88762 17.4242 3.07731 15.3636L9.3232 4.54545ZM12 6.89394C12.5523 6.89394 13 7.34165 13 7.89394V13.0455C13 13.5977 12.5523 14.0455 12 14.0455C11.4477 14.0455 11 13.5977 11 13.0455V7.89394C11 7.34165 11.4477 6.89394 12 6.89394ZM12 17.6818C12.569 17.6818 13.0303 17.2205 13.0303 16.6515C13.0303 16.0825 12.569 15.6212 12 15.6212C11.431 15.6212 10.9697 16.0825 10.9697 16.6515C10.9697 17.2205 11.431 17.6818 12 17.6818Z",
    fill: "white"
  })));
};
export default SvgWarning;